<template>

	<div class="knd-strooigoed-wrapper">
		<img class="knd-strooigoed" :src='require("@/assets/images/tiktok_strooi2.png")' />
	</div>

	<div id="knd-blok3" class="knd-blok">

		<div class="knd-blok-titel" v-html='getContent(stap, "Tussenkop")'></div>
		<div class="knd-blok-tekst" v-html='getContent(stap, "Tekst")'></div>
		<img class="knd-blok-foto" :src='require("@/assets/images/telefoon.png")' />
		<!-- <img class="knd-blok-foto2" :src='require("@/assets/images/geluid.png")' /><br/> -->

		<div class="knd-audio-wrapper">
			<video 
				playsinline
				class="knd-blok-video"
				ref="video">
				<source :src='require("@/assets/video/DJ_MAARTEN_WEDERHOOR.mp4")  + "#t=0.001"' type="video/mp4" />
				Uw browser ondersteunt het element <code>video</code> niet.
			</video>

			<div class="knd-audio-counter"><Countdown :startdate='"Jan 1, 2000 00:00:00"' :enddate='"Jan 1, 2000 00:02:41"' :play="play"></Countdown></div>

			<img 
				class="knd-blok-afspeelknop" 
				ref="playknop" 
				:src='require("@/assets/images/play.png")' 
				@click="playVideo" />
			<img 
				class="knd-blok-afspeelknop hidden" 
				ref="pauzeknop" 
				:src='require("@/assets/images/pauze.png")' 
				@click="pauseVideo" />
		</div>



		<div 
			ref="knd-transcript-knop"
			class="knd-transcript-knop"
			@click="toggleTranscript()">
			<span v-if='this.language === "nl"'>Lees het interview</span>
			<span v-if='this.language === "en"'>Read the interview</span>
			<div
				ref="knd-transcript-content" 
				class="knd-transcript-content hidden">
				<div 
					v-for='text in stap["Transcript"]'
					:key='text["naam"]'>
					<div 
						v-html='text["naam"] + ":"'
						:class='text["naam"]'></div>
					<div 
						v-html='getContent(text, "tekst")'
						:class='text["naam"]'></div>
				</div>
			</div>
		</div>
	</div>


	
		
</template>

<script>

import Countdown from './../countdown';

export default {
	name: 'Blok3',
	props: ['stap', 'language', 'mobiel'],
	data() {
		return {
			play: false,
			transcript: false
		}
	},
	mounted() {
		window.addEventListener("scroll", () => {
			if (this.$refs.video) {
				if (!this.isInViewport(this.$refs.video)) {
					if (this.play) {
						this.pauseVideo();
					}
				}
			}
		});
	},
	methods: {
		getContent(content, label) {
			if (this.language === "nl") {
				return content[label].data;
			}
			else {
				return content[label].data5891;	
			}
		},

		playVideo() {
			this.$refs.video.play();
			this.$refs.playknop.classList.add("hidden");
			this.$refs.pauzeknop.classList.remove("hidden");
			this.play = true;
		},

		pauseVideo() {
			this.$refs.video.pause();
			this.$refs.playknop.classList.remove("hidden");
			this.$refs.pauzeknop.classList.add("hidden");
			this.play = false;
		},

		isInViewport(element) {
			var rect = element.getBoundingClientRect();
			var html = document.documentElement;
			return (
				rect.top <= (window.innerHeight || html.clientHeight) && rect.top >= 0
			);
		},

		toggleTranscript() {
			if (this.transcript === false) {
				this.$refs["knd-transcript-knop"].classList.add("expanded");
				this.$refs["knd-transcript-content"].classList.remove("hidden");
			}
			else {
				this.$refs["knd-transcript-knop"].classList.remove("expanded");
				this.$refs["knd-transcript-content"].classList.add("hidden");
			}

			this.transcript = !this.transcript;
		}
	},
	components: {
		Countdown
	}
}
</script>
